import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=7b37c306&"
import script from "./Package.vue?vue&type=script&lang=ts&"
export * from "./Package.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports